import {
  DateAnswer,
  EmailAndNameAnswer,
  EmailAnswer,
  FreetextAnswer,
  HeightAnswer,
  MultipleChoiceAnswer,
  NumericAnswer,
  SingleChoiceAnswer,
} from '@/components/decision-tree/components/SurveyItem/components/Question/questionTypes';
import { AnsweredQuestion, AnsweredQuestionsType } from '@/components/decision-tree/hooks';
import { FollowUpType, QuestionnaireSummary, UserQuestionnaireType } from '@/components/decision-tree/types';
import { type Dispatch } from 'react';
import { ResultAnswer } from '../../components/SurveyItem/components/Question/questionTypes/Result';
import { SummaryAnswer } from '../../components/SurveyItem/components/Question/questionTypes/Summary';
import { WeightAnswer } from '../../components/SurveyItem/components/Question/questionTypes/Weight';

export enum HandleAnswersActions {
  SaveAnswer = 'saveAnswer',
  ResetAnswer = 'resetAnswer',
  GetPreviousAnswer = 'getPreviousAnswer',
  SetPreviousAnswers = 'setPreviousAnswers',
}

export type AnsweredQuestionsAnswerType = Record<string, AnsweredQuestion>;

export type HandleAnswersAction = {
  type: HandleAnswersActions;
  payload?: AnsweredCurrentQuestion | string | AnsweredQuestionsType;
};

export type AnsweredCurrentQuestion = {
  surveyItemId: string;
  sectionId: string;
  answer: AnswerModel;
  complete?: boolean;
};

export type SubmitAnswerFn = (currentPage: string) => Promise<UserQuestionnaireType | null>;

export type HandleAnswersState = {
  answer: AnswerModel | null;
  previousAnswers: AnsweredQuestionsAnswerType;
  isAnswered: boolean;
  complete: boolean;
};

export type useHandleActionResponse = {
  answersDispatch: Dispatch<HandleAnswersAction>;
  state: HandleAnswersState;
  submitAnswer: SubmitAnswerFn;
  submitIDKAnswer: SubmitAnswerFn;
  summary: QuestionnaireSummary | null;
  result: Array<FollowUpType> | null;
};

export type IDontKnowAnswer = {
  type: 'iDontKnow';
};

export type InterstitialAnswer = {
  type: 'interstitial';
};

export type AnswerModel =
  | SingleChoiceAnswer
  | MultipleChoiceAnswer
  | NumericAnswer
  | HeightAnswer
  | WeightAnswer
  | DateAnswer
  | EmailAnswer
  | IDontKnowAnswer
  | InterstitialAnswer
  | SummaryAnswer
  | ResultAnswer
  | FreetextAnswer
  | EmailAndNameAnswer
  | undefined;

export const iDontKnowAnswer: IDontKnowAnswer = { type: 'iDontKnow' };
export const interstitialAnswer: InterstitialAnswer = { type: 'interstitial' };
